// extracted by mini-css-extract-plugin
export default {"rejected":"styles_rejected__xWKJj","paid":"styles_paid__LjM9s","approved":"styles_approved__rBtT0"};